import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { WINNING_HANDS } from '../../../constants/winningHands';

type Winner = typeof WINNING_HANDS.WinPlayerA | typeof WINNING_HANDS.WinPlayerB;

export type StatisticState = {
  winPercentages: {
    [WINNING_HANDS.WinPlayerA]: number;
    [WINNING_HANDS.WinPlayerB]: number;
    [WINNING_HANDS.Tie]: number;
  } | {};
  lastWinners: Winner[];
};

const INITIAL_STATE: StatisticState = {
  winPercentages: {},
  lastWinners: [],
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState: INITIAL_STATE,
  reducers: {
    set(state, { payload }: PayloadAction<StatisticState>) {
      return { ...state, ...payload };
    },
  },
});

export const statisticsActions = { statistics: statisticsSlice.actions };

export default statisticsSlice.reducer;
